// extracted by mini-css-extract-plugin
export default {"filesList":"FilesList_filesList__TAn0g","itemData":"FilesList_itemData__Oy40e","fa":"FilesList_fa__6uFmw"};